(function () {
  function applyDesktopBannerFix() {
    if (document.getElementById('outlaw-desktop-banner-fix')) return;
    var style = document.createElement('style');
    style.id = 'outlaw-desktop-banner-fix';
    style.textContent = `
      /* Preserve complete artwork on the two graphic homepage banners. */
      @media screen and (min-width: 768px) {
        .template_index .banner-section {
          --sliderHeight: clamp(460px, 42vw, 560px) !important;
        }

        #yv-banner-item-slide_FiberglassPancake95 .yv-banner-image > img,
        #yv-banner-item-slide_RuggedCharms2026 .yv-banner-image > img {
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
          object-position: center center !important;
          background: #111 !important;
        }
      }

      /* Tablets need their own treatment: the theme normally switches to
         the wide desktop artwork at 768px, which crops badly on iPad-size screens. */
      @media screen and (min-width: 768px) and (max-width: 1199px) {
        .template_index .banner-section {
          --sliderHeight: clamp(440px, 62vw, 560px) !important;
        }

        #yv-banner-item-slide_FiberglassPancake95 .yv-banner-image > img,
        #yv-banner-item-slide_RuggedCharms2026 .yv-banner-image > img {
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
          object-position: center center !important;
        }

        /* Rugged Charms already has a dedicated mobile/tablet composition.
           Keep using it through tablet widths instead of the wide desktop crop. */
        #yv-banner-item-slide_RuggedCharms2026 .yv-banner-image > img.mobile-img {
          display: block !important;
        }
        #yv-banner-item-slide_RuggedCharms2026 .yv-banner-image > img.d-none.d-md-block {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDesktopBannerFix);
  } else {
    applyDesktopBannerFix();
  }
})();